







import { Component, Prop, Vue } from "vue-property-decorator";
import { Style } from "@/services/styles/types";
import { fixedHtmlCSS } from "@/services/posts/postTypes/fixedhtml";

@Component
export default class FixedHtmlStyle extends Vue {
@Prop() private itemStyle!: Style;

get model(): fixedHtmlCSS {
    return this.itemStyle.css
        ? (this.itemStyle.css as fixedHtmlCSS)
        : ({} as fixedHtmlCSS);
}
}
